
// => Styling
import styles from './CardsSetPreview.module.css';

// => Data
import { boosterPacks } from '../../../content/boosterPacks';

// => Components
import CardPreview from './CardPreview';


// ============
// Component
// ============
const CardsSetPreview = ({
    data = boosterPacks[0],
    onInspect = (d, i) => {},
    hasCardUnlocked = (id) => {},
    unlockedCards = [],
}) => {

    const setCardCount = () => {
        return data.pool.length
    }

    const unlockedCardCount = () => {
        let result = 0
        if (data.unlockOverride === true) {
            return data.pool.length
        }
        let pool = data.pool.filter(c => {
            return unlockedCards.includes(c.id) === true
        })
        result = pool.length
        return result
    }


    // RENDER
    // ---------
    return(
        <div className={styles.container}>
            <div className={styles.completion}>
                <progress className={styles.meter} id={data.id + "_meter"} value={unlockedCardCount()} max={setCardCount()}></progress>
                <span><b>Set completion:</b> {unlockedCardCount()}/{setCardCount()}</span>
            </div>
            <div className={styles.grid}>
            {data.pool.map((c, index) => 
                <CardPreview key={"card-preview_"+data.id+"_"+c.id}
                            data={c}
                            index={index}
                            unlocked={hasCardUnlocked(c.id)}
                            onInspect={(d, i)=>onInspect(d, i)} />
            )}
            </div>
        </div>
    );
}


export default CardsSetPreview